    <!-- LARGE MODAL -->
    <div class="max-w-md w-full mx-auto">
        <!-- Modal Header -->
        <div class="flex justify-between items-center p-4 border-b border-gray-200">
            <h6 class="text-lg font-semibold text-gray-800">Confirm Book Now</h6>
            <button 
                type="button" 
                class="text-gray-400 hover:text-gray-500 focus:outline-none"
                (click)="close()"
            >
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        
        <!-- Modal Body -->
        <div class="p-6">
            <div class="text-center">
                <span class="text-red-600 font-medium">
                    Are you sure you want to book all services on this itinerary?<br/>
                    <b class="font-semibold">There may be cancellation penalties.</b>
                </span>
            </div>
        </div>
        
        <!-- Modal Footer -->
        <div class="flex justify-between items-center p-4 border-t border-gray-200">
            <button 
                type="button" 
                class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                (click)="itinPersonAdd(data.quote, true)"
            >
                Yes
            </button>
            <button 
                type="button" 
                class="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                (click)="close()"
            >
                No
            </button>
        </div>
    </div>